const routes = {
  shifts: 'Working Hours',
  passengers: 'Employees'
};

export default routes;
